import Dinero from "dinero.js";
import * as React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";

// global dinero config
Dinero.defaultCurrency = "EUR";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
